import React from 'react';
import classNames from 'classnames';

interface MobilityHeaderLabelTextProps {
  name?: string;
  labelText?: string;
  isError?: boolean;
  isRequired?: boolean;
  className?: string;
}

export const MobilityHeaderLabelText: React.FC<MobilityHeaderLabelTextProps> = ({
  labelText,
  isError,
  isRequired,
  name,
  className,
}) => {
  if (labelText === undefined) {
    return null;
  }

  const utilityClassName = `w-full block whitespace-pre-line ${
    isError ? 'text-text-error' : 'text-text-default-content'
  }`;
  const text = `${labelText}${isRequired ? ' *' : ''}`;

  return (
    <label htmlFor={name} className={classNames(className, utilityClassName)}>
      {text}
    </label>
  );
};
